<template>
  <div class="page tmdRepaymentConfirm">
    <navigation class="header flex-shrink0">确认提交</navigation>
    <section class="section flex-shrink0">
      <div class="card">
        <div class="card-amount">
          <h2 class="title">确认提交金额 (元)</h2>
          <p>
            {{ detail.totalPaidAmt | currency }}
            <img @click="detailDialogVisible = true" v-if="detail.rightsAmt > 0" src="../images/icon_info.png" />
          </p>
        </div>

        <div class="repay-list" v-if="detail.wavAmt > 0">
          <div class="repay-list-item">
            <p class="thin">待提交金额（元）</p>
            <p>{{ detail.repayAmt | currency }}</p>
          </div>
          <div class="repay-list-item" >
            <p class="thin">减免金额（元）</p>
            <p>-{{ detail.wavAmt | currency }}</p>
          </div>
        </div> 
        <div v-else style="height:1rem"></div>
      </div>

      <section class="account-title">
        <div class="title">扣款账户详情</div>
        <p>为避免逾期风险，请您确保银行卡余额充足。本次还款将从以下银行卡扣款。</p>
      </section>

      <section class="account-list">
        <div class="item" v-for="(item, index) in detail.showCards" :key="index">
          <div class="bank-container">
            <img :src="loadBankIcon(item.bankCardCode)">
            <div class="bank-info">
              <span>{{ item.bankCardName }}</span>
              <p>{{ item.bankCardNo | bankCardNo }}</p>
            </div>
          </div>
          <div class="amount-info">
            <span>还款金额 (元)</span>
            <p>{{ item.repayAmt | currency }}</p>
          </div>
        </div>
      </section>
    </section>

    <div class="footer flex-shrink0">
      <nd-button class="btn" @click="handleBindCard" :disabled="loading">确认提交</nd-button>
      <p>点击「确认提交」按钮即代表您同意并授权提交以上扣款操作</p>
    </div>

    <nd-dialog v-model="detailDialogVisible" :footer="false" :close-btn="true">
      <div class="detail-dialog" 
           data-sensors-exposure-event-name="Element_Exposure"  
           data-sensors-exposure-property-caseId="QUICK_REPAYMENT_INFO"
           data-sensors-exposure-property-element_positon="dialog"
      >
        <div class="title">确认提交金额</div>
        <div class="content-detail">
          本次提交金额中，含有<span class="red">{{ detail.rightsAmt | currency }}</span>元三方平台消费账单，具体详情请咨询三方平台。
        </div>
      </div>
    </nd-dialog>

    <diglogSms v-model="smsVisible"  @retrieve="retrieve" @confirm="handleConfirmBind" :cardInfo="cardInfo"></diglogSms>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'quick-repayment-confirm',
  components: {
    diglogSms: () => import('./components/dialog-sms')
  },
  data () {
    return {
      smsVisible: false,
      pending: false,
      detailDialogVisible: false,
      loading: false,
      detail: {
        repayAmt: 0,
        totalPaidAmt: 0,
        wavAmt: 0,
        rightsAmt: 0,
        showCards: [],
        bindCards: [] // 待绑卡列表，如果空了就调确认接口去结果页
      },
      repayOrderSelect: [],
      repayExpenseSelect: [],
      cardInfo: {},
      msgInfo: {},
      clearList: false,
      clearRightsList: false,
      RightSelected: false // 是否勾选了权益
    }
  },

  async created () {
    this.repayOrderSelect = JSON.parse(sessionStorage.getItem('repayOrderSelect') || '[]')
    this.repayExpenseSelect = JSON.parse(sessionStorage.getItem('repayExpenseSelect') || '[]')
    this.getTrial()
    this.$bus.$emit('ready')
  },

  methods: {
    ...mapActions('order', ['getRepayBatchTrialX', 'getRepayBatchConfirmX', 'getRepayBatchResultX']),
    ...mapActions('bankcard', ['bindBankcardApplyX', 'bindBankcardConfirmX']),
    async getTrial () {
      this.loading = true
      const { success, data } = await this.getRepayBatchTrialX({
        loanList: this.repayOrderSelect,
        rightsList: this.repayExpenseSelect?.length ? this.repayExpenseSelect : []
      })
      this.loading = false
      if (success) {
        this.detail = data || {}
      } else {
        sessionStorage.removeItem('repayOrderSelect')
        sessionStorage.removeItem('repayExpenseSelect')
        this.$router.go(-1)
      }
    },
    // 确认绑卡
    async handleConfirmBind (smsCode) {
      const { loanPlatform, fundCode } = this.cardInfo
      const params = {
        smsKey: this.msgInfo.smsKey,
        loanPlatform,
        fundCode,
        smsCode
      }
      const { success } = await this.bindBankcardConfirmX(params)
      if (success) {
        this.handleBindCard()
        this.smsVisible = false
      }
    },
    // 重新发送验证码
    async retrieve (reset) {
      await this.bindBankcardApply()
      reset()
    },
    async bindBankcardApply () {
      const params = this.detail.bindCards[0]
      this.cardInfo = params || {}
      const { success, data } = await this.bindBankcardApplyX(params)
      if (success) {
        this.msgInfo = data
        this.smsVisible = true
      }
    },
    loadBankIcon (bankCode) {
      try {
        return require(`../../bankcard/images/${bankCode.toLowerCase()}.jpg`)
      } catch (e) { }
    },
    async handleBindCard () {
      await this.getTrial()
      if (!this.detail.bindCards?.length) {
        this.confirmRepay()
      } else {
        this.bindBankcardApply()
      }
    },
    async confirmRepay () {
      const { success, data } = await this.getRepayBatchConfirmX({
        loanList: this.repayOrderSelect,
        rightsList: this.repayExpenseSelect?.length ? this.repayExpenseSelect : []
      })
      if (success) {
        this.$router.replace({
          path: '/quickRepay/result',
          query: {
            batchNo: data
          }
        })
      }
    },
    reBind () {

    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.flex-shrink0 {
  flex-shrink: 0;
}

.label {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);

  >img {
    width: 44px;
    height: 44px;
    margin-right: 16px;
  }
}

.page {
  height: 100%;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;

  .account-list {
    background: #fff;
    margin-top: 20px;

    .item {
      display: flex;
      padding: 30px;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eeeeee;

      img {
        width: 60px;
        height: 60px;
      }

      .bank-container {
        display: flex;
        align-items: center;
        gap: 10px;
        border-radius: 60px;
      }

      .bank-info,
      .amount-info {
        font-size: 26px;
        color: #333333;
      }

      .amount-info {
        text-align: right;

      }
    }
  }

  .account-title {
    margin-top: 60px;
    padding: 0 30px;
    ;

    .title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #333333;
    }

    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #999999;
    }
  }

  .section {
    // overflow: scroll;
    flex: 1;

    .card {
      border-radius: 20px;
      padding: 22px 0 0 0;
      background-color: #ffffff;
      box-sizing: border-box;
      margin: 30px;

      .platform {
        padding: 0 30px;
        height: 36px;
        line-height: 36px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .icon {
          width: 36px;
          height: 36px;
        }

        .name {
          font-size: 26px;
          padding-left: 8px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }

      .card-amount {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 65px;
        font-size: 72px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 67px;
        text-align: center;

        h2 {
          font-weight: 400;
          font-size: 24px;
          color: #333333;
        }

        img {
          width: 23px;
          height: 23px;
          margin-bottom: 20px;
        }
      }

      .origin-amount {
        font-size: 24px;
        height: 33px;
        line-height: 33px;
        margin-top: 13px;
        text-align: center;
        text-decoration: line-through;
        color: @fc3;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }

      .repay-list {
        margin-top: 74px;
        display: grid;
        grid-template-columns: 50% 50%;
        // grid-row-gap: 7px;
        font-size: 24px;
        text-align: left;
        color: #333333;
        line-height: 33px;
        border-top: 1px solid #eeeeee;

        .repay-list-item {
          height: 99px;
          padding: 14px 30px 11px;

          &:nth-child(2n) {
            border-left: 1px solid #eeeeee;
          }

          .thin {
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 33px;
            margin-bottom: 4px;
          }
        }
      }
    }
  }

  .footer {
    height: 210px;
    background-color: #ffffff;

    .btn {
      margin: 28px auto 0;
    }

    p {
      text-align: center;
      font-size: 24px;
      color: #999999;
      margin-top: 20px;
    }
  }

  .detail-dialog {
    padding: 0 30px 60px;

    .title {
      font-size: 42px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 72px;
      text-align: center;
    }

    .content-detail {
      margin-top: 30px;
      font-size: 28px;
      line-height: 40px;

      .red {
        color: #FF4633;
      }
    }
  }

}
</style>
